var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2851_1451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1D2838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7499 11.375V15.125C26.7499 15.2908 26.6841 15.4498 26.5669 15.567C26.4497 15.6842 26.2907 15.75 26.1249 15.75H22.3749C22.2092 15.75 22.0502 15.6842 21.933 15.567C21.8158 15.4498 21.7499 15.2908 21.7499 15.125C21.7499 14.9593 21.8158 14.8003 21.933 14.6831C22.0502 14.5659 22.2092 14.5 22.3749 14.5H24.5155L22.4382 12.5969L22.4187 12.5782C21.55 11.7098 20.4447 11.1166 19.2408 10.8728C18.037 10.629 16.788 10.7453 15.6498 11.2071C14.5117 11.669 13.5349 12.456 12.8414 13.4698C12.148 14.4837 11.7686 15.6793 11.7508 16.9075C11.7329 18.1356 12.0773 19.3418 12.741 20.3754C13.4046 21.409 14.3581 22.224 15.4824 22.7189C16.6066 23.2137 17.8517 23.3662 19.0621 23.1575C20.2725 22.9488 21.3946 22.3881 22.2882 21.5453C22.4087 21.4314 22.5695 21.37 22.7353 21.3746C22.9011 21.3792 23.0582 21.4495 23.1722 21.57C23.2861 21.6904 23.3476 21.8513 23.343 22.017C23.3383 22.1828 23.2681 22.34 23.1476 22.4539C21.7581 23.7717 19.9149 24.5043 17.9999 24.5H17.8968C16.6685 24.4832 15.4631 24.1649 14.3866 23.5731C13.3101 22.9814 12.3954 22.1342 11.7229 21.1062C11.0505 20.0781 10.6409 18.9006 10.5301 17.6772C10.4193 16.4537 10.6107 15.2218 11.0875 14.0897C11.5643 12.9575 12.3119 11.9599 13.2646 11.1843C14.2173 10.4088 15.3459 9.87912 16.5512 9.6419C17.7565 9.40468 19.0017 9.46716 20.1772 9.82385C21.3527 10.1805 22.4226 10.8205 23.2929 11.6875L25.4999 13.7032V11.375C25.4999 11.2093 25.5658 11.0503 25.683 10.9331C25.8002 10.8159 25.9592 10.75 26.1249 10.75C26.2907 10.75 26.4497 10.8159 26.5669 10.9331C26.6841 11.0503 26.7499 11.2093 26.7499 11.375Z",
    fill: "url(#paint0_linear_2851_1451)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#475569"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2851_1451",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.101961 0 0 0 0 0.164706 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2851_1451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2851_1451",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2851_1451",
    x1: 26.7499,
    y1: 9.50073,
    x2: 10.4995,
    y2: 9.50073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#D378F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.272312369e0bd7beeeab1d2413f2f54a.svg";
export { ForwardRef as ReactComponent };